import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Avatar, Box, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography,
} from '@mui/material';
import { AdminPanelSettingsOutlined, Logout, PersonOutline, ReceiptLongOutlined } from '@mui/icons-material';
import { useAuthStore, isAdmin, initials } from '../stores/authStore';

export default function UserMenu() {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  if (!user) return null;
  const close = () => setAnchor(null);
  const go = (path: string) => {
    close();
    navigate(path);
  };

  return (
    <>
      <IconButton
        onClick={(e) => setAnchor(e.currentTarget)}
        aria-label="Compte"
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
        sx={{ p: 0.5, flexShrink: 0 }}
      >
        <Avatar sx={{ width: 36, height: 36, bgcolor: 'primary.main', fontSize: '0.95rem', fontWeight: 700 }}>
          {initials(user)}
        </Avatar>
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { mt: 1, minWidth: 240, borderRadius: 2 } } }}
      >
        <Box sx={{ px: 2, py: 1.25 }}>
          {user.name && (
            <Typography sx={{ fontWeight: 600 }} noWrap>
              {user.name}
            </Typography>
          )}
          <Typography variant="body2" color="text.secondary" noWrap>
            {user.email}
          </Typography>
        </Box>
        <Divider />
        <MenuItem onClick={() => go('/compte')}>
          <ListItemIcon>
            <PersonOutline fontSize="small" />
          </ListItemIcon>
          <ListItemText>Mon compte</ListItemText>
        </MenuItem>
        {isAdmin(user) && [
          <MenuItem key="admin" onClick={() => go('/admin')}>
            <ListItemIcon>
              <AdminPanelSettingsOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText>Administration</ListItemText>
          </MenuItem>,
          <MenuItem key="facturation" onClick={() => go('/facturation')}>
            <ListItemIcon>
              <ReceiptLongOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText>Facturation</ListItemText>
          </MenuItem>,
        ]}
        <Divider />
        <MenuItem
          onClick={async () => {
            close();
            await logout();
            navigate('/login', { replace: true });
          }}
        >
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          <ListItemText>Déconnexion</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
